import _objectWithoutProperties from "/home/bamboo/bamboo-agent-home/xml-data/build-dir/DETOX-SHOP218-JOB1/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["title", "titleId"];
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import * as React from "react";
function Thumbsup(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 16,
    height: props.size || 16,
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M15.22 2.514a2.486 2.486 0 011.103 2.078v4.081h3.04c.77 0 1.591.058 2.436.743a3.043 3.043 0 011.121 2.77 1.032 1.032 0 01-.024.133l-1.749 6.813c-.297.94-1.218 2.436-2.883 2.436h-7.837c-1.242 0-2.214-.684-3.023-1.461A2 2 0 015.5 21.5H3c-1.103 0-2-.897-2-2V10c0-1.103.897-2 2-2h2.5c.397 0 .767.116 1.079.316l4.294-5.035a3.805 3.805 0 011.507-1.074c.921-.364 2.036-.24 2.84.307zm-2.11 1.554a1.839 1.839 0 00-.716.512L7.5 10.32v6.985l.164.171c.113.12.23.246.347.375.74.805 1.576 1.718 2.416 1.718h7.837c.614 0 .96-.984.964-.994l1.711-6.678a1.048 1.048 0 00-.4-.928c-.293-.237-.524-.295-1.177-.295h-4.039a1 1 0 01-1-1v-5.08a.472.472 0 00-.23-.426c-.262-.178-.675-.218-.983-.099zM5.5 10H3v9.5h2.501L5.5 10z",
    fill: props.color || "#222",
    fillRule: "evenodd"
  }));
}
var MemoThumbsup = React.memo(Thumbsup);
export default MemoThumbsup;